import { useTranslations } from 'next-intl';

import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { utilEventCartModal } from '@/fo/util/event-cart-modal';

export function EmptyCart() {
  const t = useTranslations();

  return (
    <div className="mx-auto flex flex-col items-start md:min-w-[350px]">
      <p className="heading-3xl max-md:heading-2xl font-[450]">
        {t('cart-emtpy-title')}
      </p>
      <p className="heading-m max-md:heading-s mt-3">{t('cart-empty-offer')}</p>
      <UiKitButtonBase
        color="secondary"
        className="mt-8 w-full"
        as="link"
        href="/catalog"
        onClick={() => utilEventCartModal.close()}
      >
        {t('cart-empty-action')}
      </UiKitButtonBase>
    </div>
  );
}
